// extracted by mini-css-extract-plugin
module.exports = {"toast":"style_toast__Wo3ZC","modal":"style_modal__1PC6P"};